"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode, useState } from "react";
import dynamic from "next/dynamic";
import { QueryClient, QueryClientProvider, QueryCache, MutationCache } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { shouldPreserveCachedQueryData } from "@/shared/lib/query-error-policy";
const ToastMessage = dynamic(() => import("@/shared/ui/molecules/ToastMessage"), {
  ssr: false
});
const createQueryClient = () => {
  const queryCache = new QueryCache({
    onError: (error: unknown, query) => {
      if (shouldPreserveCachedQueryData(query)) return;
      if (typeof window !== "undefined") {
        const currentPath = window.location.pathname;
        if (currentPath.includes("/error")) {
          return;
        }
        const locale = currentPath.split("/")[1] || "ko";
        const axiosError = error as {
          response?: {
            status?: number;
          };
        };
        const status = axiosError?.response?.status;
        if (status && status < 500) {
          return;
        }
        if (process.env.NODE_ENV === "development") return;
        window.location.href = `/${locale}/error`;
      }
    }
  });
  const mutationCache = new MutationCache({
    onError: (error: unknown) => {
      if (typeof window !== "undefined") {
        const currentPath = window.location.pathname;
        if (currentPath.includes("/error")) {
          return;
        }
        const locale = currentPath.split("/")[1] || "ko";
        const axiosError = error as {
          response?: {
            status?: number;
          };
        };
        const status = axiosError?.response?.status;
        if (status && status < 500) {
          return;
        }
        if (process.env.NODE_ENV === "development") return;
        window.location.href = `/${locale}/error`;
      }
    }
  });
  return new QueryClient({
    queryCache,
    mutationCache,
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        gcTime: 5 * 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: false
      },
      mutations: {
        retry: 0
      }
    }
  });
};
export const QueryProvider = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [queryClient] = useState(_temp);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ToastMessage />;
    t2 = <ReactQueryDevtools initialIsOpen={false} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== queryClient) {
    t3 = <QueryClientProvider client={queryClient}>{children}{t1}{t2}</QueryClientProvider>;
    $[2] = children;
    $[3] = queryClient;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
function _temp() {
  return createQueryClient();
}